import React from 'react';
import { Check } from 'lucide-react';
import { ABOUT_BULLETS, IMAGES } from '../mock';

export default function About() {
  return (
    <section id="o-firmie" className="bg-white py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden">
              <img src={IMAGES.about} alt="Adrian Nowak - Inżynier" className="w-full h-[520px] object-cover" />
              <div className="absolute left-4 right-4 bottom-4 rounded-xl bg-[#132a44]/85 backdrop-blur px-5 py-4">
                <div className="font-heading font-bold text-[18px] text-white">Adrian Nowak</div>
                <div className="text-[13px] text-[#f5c518]">Inżynieria Elektryczna, automatyka i nadzór</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">O FIRMIE</div>
            <h2 className="font-heading font-extrabold text-[36px] md:text-[46px] leading-[1.08] tracking-tight text-[#0f1a2b]">
              Wiedza techniczna. Odpowiedzialność. Konkretne rozwiązania.
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#0f1a2b]/75">
              Łączę kompetencje z zakresu automatyki przemysłowej oraz branży elektrycznej, od koncepcji i projektu, przez wycenę i realizację, po nadzór i odbiór. Wspieram inwestorów oraz firmy przemysłowe w podejmowaniu właściwych decyzji technicznych, opierając współpracę na rzetelności i konkretnych rozwiązaniach.
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-[#0f1a2b]/75">
              Wsparcie techniczne oparte na wiedzy, odpowiedzialności i konkretnych rozwiązaniach, dopasowane do specyfiki Twojej inwestycji.
            </p>

            <ul className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
              {ABOUT_BULLETS.map((b) => (
                <li key={b} className="flex items-start gap-3 text-[14px] text-[#0f1a2b]/85">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#f5c518] flex-shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
